import { render, staticRenderFns } from "./communicationconfig.vue?vue&type=template&id=32fa2012&scoped=true"
import script from "./communicationconfig.vue?vue&type=script&lang=js"
export * from "./communicationconfig.vue?vue&type=script&lang=js"
import style0 from "./communicationconfig.vue?vue&type=style&index=0&id=32fa2012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fa2012",
  null
  
)

export default component.exports